export default (width = 24, height = 24, color = '#797979') => `
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 24 24">
    <path fill="${color}" d="M13 9.8H0V8h13v1.8zM10 2H0v1.8h10V2zm6 12H0v1.8h16V14zM0 21.8h23v-1.7L0 20v1.8zm23.2-11.7h-2.4V2H19v8.1h-2.8l3.5 4.6 3.5-4.6z"/>
</svg>
`
